import { LogoutRounded, VideoCallOutlined } from "@mui/icons-material";
import { Button, Divider, Link, Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { AvatarGroup, MeetingTimer } from "..";
import { Links, MeetingType } from "../../constants";
import { GetOneOnOneMeetingDto, GetTeamMeetingDto, MeetingInstanceDto, UserDto } from "../../http";

interface IProps {
  meeting: GetTeamMeetingDto | GetOneOnOneMeetingDto;
  meetingInstance: MeetingInstanceDto;
  externalCallUrl?: string;
  participants?: UserDto[];
  isMeetingEnding: boolean;
  onLeaveMeetingClicked?: () => void;
  onCloseMeetingClicked: () => void;
}

const MeetingHeader = (props: IProps) => {
  const meetingStartedAtDateTime = DateTime.fromISO(props.meetingInstance.startedAtDateTimeUtc, { zone: "utc" })
    .toLocal()
    .toLocaleString(DateTime.DATETIME_FULL);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "flex-start",
        justifyContent: "space-between"
      }}>
      <Stack spacing={0.5}>
        <Typography variant="h3">
          {props.meeting.type === MeetingType.Team
            ? props.meeting.title
            : `1:1 ${props.meeting.otherUser.displayName}, ${props.meeting.leadUser.displayName}`}
        </Typography>
        <Stack direction="row" spacing={0.25}>
          {props.meeting.type === MeetingType.Team ? (
            <Typography>
              <Typography variant="body2" sx={{ display: "inline" }}>
                {props.meeting.team.name}
              </Typography>{" "}
              meeting started by
            </Typography>
          ) : (
            <Typography>Started by</Typography>
          )}
          <Link href={Links.User(props.meetingInstance.startedByUser.userId)}>
            {props.meetingInstance.startedByUser.displayName}
          </Link>
          <Stack
            direction="row"
            spacing={0.25}
            divider={<Divider flexItem orientation="vertical" sx={{ height: 16, alignSelf: "center" }} />}
          >
            <Typography>on {meetingStartedAtDateTime}</Typography>
            <Typography>
              Running Time{" "}
              <MeetingTimer
                startDateTimeUtc={DateTime.fromISO(props.meetingInstance.startedAtDateTimeUtc, { zone: "utc" })}
              />
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={{ xs: 0.5, sm: 1 }} sx={{
          alignItems: "center"
        }}>
          <AvatarGroup users={props.participants ?? []} avatarProps={{ size: "small" }} max={10} />
          <Button
            variant="tertiary"
            startIcon={<LogoutRounded />}
            onClick={props.onCloseMeetingClicked}
            disabled={props.isMeetingEnding}
          >
            End Meeting For All
          </Button>

          {props.onLeaveMeetingClicked && (
            <Button
              variant="tertiary"
              startIcon={<LogoutRounded />}
              onClick={props.onLeaveMeetingClicked}
              disabled={props.isMeetingEnding}
            >
              Leave Meeting
            </Button>
          )}

          {props.externalCallUrl && (
            <Button
              variant="tertiary"
              startIcon={<VideoCallOutlined />}
              href={props.externalCallUrl}
              disabled={props.isMeetingEnding}
              target="_blank"
              rel="noopener noreferrer"
            >
              Join Call
            </Button>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export { MeetingHeader };
